export var systemIndex = {
    transaction_date: {
        label: 'Data',
        index: 'transaction_date',
        group: 'Informações Básicas',
        required: true,
    },
    description: {
        label: 'Descrição',
        index: 'description',
        group: 'Informações Básicas',
        required: true,
    },
    amount: {
        label: 'Valor',
        index: 'amount',
        group: 'Informações Básicas',
        required: true,
    },
    document_number: {
        label: 'Documento',
        index: 'document_number',
        group: 'Identificação',
        required: false,
    },
};

export var examplePerIndex = {
    transaction_date: '15/01/2026',
    description: 'TED RECEBIDO - EMPRESA XYZ',
    amount: '1500.00',
    document_number: '123456',
};
